import AuthProvider from './AuthProvider';

export function install(Vue) {
  Vue.component(AuthProvider.name, AuthProvider);
}

export { AuthProvider };
